import { makeStyles } from '@material-ui/core'
import React from 'react'

import EmptyCard from '../assets/images/emptylawyer.png'
import ChipConnected from './ChipConnected'

const DEFAULT_SIZE = 190

const useStyle = makeStyles({
  pictureContainer: ({ size }) => ({
    position: 'relative',
    width: size,
    height: size,
  }),
  picture: ({ size, zIndex }) => ({
    filter: 'grayscale(100%)',
    width: size,
    height: size,
    position: 'absolute',
    borderRadius: '50%',
    border: `1px solid #D5DEE6`,
    overflow: 'hidden',
    zIndex,

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  }),
  connectedBlock: ({ zIndex }) => ({
    position: 'absolute',
    bottom: '5%',
    right: '5%',
    zIndex,
    border: `2px solid #ffffff`,
    borderRadius: '50%',
  }),
})

const LawyerPicture = ({
  lawyerToDisplay,
  size = DEFAULT_SIZE,
  stylePictureContainer = {},
  zIndex = 2,
}) => {
  const classes = useStyle({ size, zIndex })

  return (
    <div className={classes.pictureContainer} style={stylePictureContainer}>
      <div className={classes.picture}>
        <img src={lawyerToDisplay?.photoUrl || EmptyCard} alt={lawyerToDisplay.lastname} />
      </div>
      <ChipConnected
        available={lawyerToDisplay.isAvailable}
        dateUpdated={lawyerToDisplay.updatedAt}
        className={classes.connectedBlock}
        hideText
        iconSize={(size * 15) / 100}
      />
    </div>
  )
}

export default LawyerPicture
